/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import DomainModel from 'cio/models/domain';
import AnalyticsService from 'cio/services/analytics';

interface LinkTrackingComponentArgs {
  domains: DomainModel[];
  canSkip: boolean;
  selectedDomain: string;
  onSelect: (domain: DomainModel | null) => unknown;
}

export default class DomainsListSetupLinkTracking extends Component<LinkTrackingComponentArgs> {
  @service analytics!: AnalyticsService;

  get sortedDomains() {
    return _sortBy(this.args.domains, ['domain']);
  }

  @action
  toggleDomain(domain: DomainModel) {
    if (this.args.selectedDomain === domain.domain) {
      this.resetSelected();
    } else {
      this.args.onSelect(domain);
      this.analytics.track('email', 'link_tracking_domain_viewed');
    }
  }

  @action
  resetSelected() {
    this.args.onSelect(null);
  }
}
